import { render, staticRenderFns } from "./seleteLive.vue?vue&type=template&id=cf3a3a48&scoped=true&"
import script from "./seleteLive.vue?vue&type=script&lang=js&"
export * from "./seleteLive.vue?vue&type=script&lang=js&"
import style0 from "./seleteLive.vue?vue&type=style&index=0&id=cf3a3a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3a3a48",
  null
  
)

export default component.exports